export default "__VITE_ASSET__679bb10d__"